<template>
  <div class="day-morning part">
    <div class="header"/>
    <div class="body" @click="clickChange(planData?.room,planData.identify, planData.id)">
      <div class="title">{{ planData?.name }}</div>
      <div class="room">
        <div v-for="(room, index) in planData?.room" :key="index">
          <div class="room-name">{{ room.room }}：</div>
          <div class="room-person">
            <span
              v-for="(person,newIndex) in room.persons"
              :key="newIndex"
            >
              {{ person.name }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MorningPlan",
  props: {
    planData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  emits: ["clickChangePlan"],
  methods: {
    clickChange(data, identify, id) {
      this.$emit("clickChangePlan", data, identify, id);
    }
  }
};
</script>

<style scoped lang="scss">


</style>
